define(["require", "exports", "hypo_bvo/Drklein/Shared/AgentService", "@drklein/locale-formatter", "jquery"], function (require, exports, AgentService_1, locale_formatter_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Initialisiert die Kundenbewertungsteaser-Komponente
     * Lädt Bewertungsdaten und aktualisiert die UI entsprechend
     */
    $(function () {
        var queryParam = {};
        var hypoport = window.hypoport;
        var produktsparte = "Gesamt";
        var produktsparteSchemaOrgName = "Baufinanzierung, Versicherung, Ratenkredit";
        if (hypoport === null || hypoport === void 0 ? void 0 : hypoport.produktsparteSeitenbaum) {
            produktsparte = hypoport.produktsparteSeitenbaum;
        }
        var kundenBewertungLinkText = "Alle Kundenbewertungen im Überblick";
        if (produktsparte !== "Gesamt") {
            queryParam = {
                platformProductGroupId: produktsparte.toUpperCase(),
            };
            kundenBewertungLinkText = "Alle Kundenbewertungen für " + produktsparte + " im Überblick";
            produktsparteSchemaOrgName = produktsparte;
        }
        var $kundenbewertungsteaserList = $(".kundenbewertungsteaserStandalone");
        var anzahlBewertungen = $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_anzahlBewertungen");
        var kundenbewertungNote = $kundenbewertungsteaserList.find(".kundenbewertungNote_noteState");
        var kundenEmpfehlung = $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_empfehlungQuote");
        var kundenBewertungLink = $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_kundenbewertungsseiteLink");
        if ($kundenbewertungsteaserList.length) {
            setKundenbewertungsteaserByProduktsparte();
        }
        /**
         * Lädt Kundenbewertungsdaten von der API und aktualisiert die UI
         * @throws {Error} Wenn die API-Anfrage fehlschlägt
         */
        function setKundenbewertungsteaserByProduktsparte() {
            $.get((0, AgentService_1.getRatingPath)(), queryParam)
                .then(function (rating) {
                if (rating.numberOfRatings > 0) {
                    setRatingValues(Number(rating.numberOfRatings), Number(rating.averageRating), Number(rating.recommendationPercent));
                    $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_noKundenbewertungsteaserDataFallback").slideUp("fast");
                    $kundenbewertungsteaserList.find(".kundenbewertungsteaserStandalone_dynamicallyEnhancedContent").slideDown("slow");
                }
            })
                .catch(function (error) {
                console.error("Fehler beim Laden der Kundenbewertungen:", error);
            });
        }
        /**
         * Setzt die Bewertungswerte in der UI
         * @param nrOfRatings - Anzahl der Bewertungen
         * @param averageRating - Durchschnittliche Bewertung
         * @param recommendationPercent - Empfehlungsquote in Prozent
         */
        function setRatingValues(nrOfRatings, averageRating, recommendationPercent) {
            $(kundenBewertungLink).each(function (index, element) {
                $(element).text(kundenBewertungLinkText);
            });
            $(anzahlBewertungen).each(function (index, element) {
                $(element).text((0, locale_formatter_1.numberWithThousandsSeparator)(nrOfRatings, 0).toString());
            });
            $(kundenbewertungNote).each(function (index, element) {
                var formattedValue = (0, locale_formatter_1.percentage)(averageRating).toString();
                // Entferne das %-Symbol (letzte 2 Zeichen) für die Anzeige
                var formattedValueWithoutSymbol = formattedValue.substring(0, formattedValue.length - 2);
                $(element).text(formattedValueWithoutSymbol);
            });
            $(".kundenbewertungsteaserDetails_kundenbewertung .starsRating_stars.starsRating_stars--is-foreground").each(function (index, element) {
                $(element).css("width", averageRating * 20 + "%");
            });
            $(kundenEmpfehlung).each(function (index, element) {
                $(element).text((0, locale_formatter_1.percentage)(recommendationPercent).toString());
            });
        }
    });
});
